import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ElementModel } from 'projects/core/src/lib/models/element.model';
import { TranslocoService } from '@ngneat/transloco';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-element-basedata',
  templateUrl: './element-basedata.component.html',
  styleUrls: ['./element-basedata.component.scss']
})
export class ElementBasedataComponent implements OnInit {

  @Input() exercise: ExerciseModel = null;
  @Input() element: ElementModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public inEdit = false;
  public submitting = false;
  public types: Array<SelectItem>;
  public inheritVisible = false;
  public form: UntypedFormGroup = this.fb.group({
    name: new UntypedFormControl('', [Validators.required]),
    title: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required])
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private route: ActivatedRoute,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.types = [{
      value: 'html',
      label: this.transloco.translate('common.labels.html-file')
    }];
    this.ui.setFocus();
  }

  public onEdit(): void {
    if (this.auth.hasRight('admin.element.edit')) {
      this.startEdit();
    }
  }

  public onCancel(): void {
    this.stopEdit();
  }

  public onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      if (this.exercise?.shouldShowInheritDialog()) {
        this.inheritVisible = true;
      } else {
        this.saveBasedata(false);
      }
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  public saveBasedata(inherit: boolean = false): void {
    this.submitting = true;
    const payload = this.form.value;
    payload.inherit = inherit;
    this.api.saveModel('elements', this.element.id, payload).subscribe({
      next: (result: any) => {
        this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.form.value.name }), this.transloco.translate('common.saved'));
        if (this.element.id !== result.data.id) {
          this.route.params.subscribe(params => {
            this.router.navigate(['/exercises', this.exercise.id, 'elements', result.data.id], { replaceUrl: true });
          });
        } else {
          this.element.deserialize(result.data);
        }
        this.stopEdit();
      },
      error: (error: any) => {
        this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
        FormHelper.setBackendErrors(this.form, error.fielderrors);
      }
    }).add(() => {
      this.submitting = false;
    });
  }

  public startEdit(): void {
    if (this.element !== null) {
      this.form.patchValue({
        name: this.element.name,
        title: this.element.title,
        type: this.element.type
      });
    }
    this.inEdit = true;
    this.setEdit.emit('basedata');
    this.ui.setFormFocus();
  }

  public stopEdit(): void {
    this.inEdit = false;
    this.setEdit.emit(null);
    this.ui.setFocus();
  }

}
